<template>
    <div id="nivel" class="contenedor">
        <Sidebar></Sidebar>
        <v-container fluid class="level text-center ma-0 px-0 pt-6 pb-0">
            <v-row class=""></v-row>
        </v-container>
    </div>
</template>
<script>
    import Sidebar from "@/components/Sidebar.vue";
    export default {
        components: {
            Sidebar
        },
        data() {
            return{
                stepn:'7-N'
            }
        },
        methods:{
            nombre(){
                localStorage.stepn=this.stepn
            }
        },
        created(){
            this.nombre();
        }
    }
</script>